import React from 'react'
import Edit from "../../../assets/images/editinput.svg";
import { Formik } from "formik";
import {Select} from "@appkit4/react-components/select"
import PropTypes from 'prop-types'
import * as Yup from "yup";
import displayToastMessage from "../../../../src/components/Common/Alert/displayToastMessage";


function OrganisationForm({
    InitialValues,
    handleReset,
    handleSubmit,
    validationSchema,
    loading
}) {

  const dropdownData = [{
    value: 1,
    label: "Level 1"
  }, {
    value: 2,
    label: "Level 2"
  }, {
    value: 3,
    label: "Level 3"
  }, {
    value: 4,
    label: "Level 4"
  }, {
    value: 5,
    label: "Level 5"
  }, {
    value: 6,
    label: "Level 6"
  }]
    return (
        <Formik
    initialValues={InitialValues}
      onReset={handleReset}
      onSubmit={handleSubmit}
      validationSchema={validationSchema}
      enableReinitialize
    >
      {(props) => {
        const {
          values,
          touched,
          errors,
          isSubmitting,
          handleChange,
          handleBlur,
          handleSubmit,
          handleReset,
        } = props;
        return (
          <div className="create-vendor-form-container">
            {loading ? (
              <div className="row" id="preloader">
              <div className="col-12 col-lg-12 loader-margin text-center">
                <div className="a-loading a-primary a-m-10">
                  <span className="sr-only">Loading...</span>
                </div>
              </div>
            </div>
            ) : (
              <form onSubmit={handleSubmit}>
                <div className="row">
                <div className="col-sm-6">
                    <div className="cv-input-field-container">
                      <label htmlFor='OrganizationNameForm' className="cv-input-label">
                      Organization<span className="asterisk-required">*</span>
                      </label>
                      <input
                        className="cv-input-field pl-2"
                        onBlur={handleBlur}
                        id='OrganizationNameForm'
                        type="text"
                        placeholder="Please enter Organization"
                       value={values.organizationName}
                        onChange={handleChange("organizationName")}
                        name="organizationName"
                      />
                      <img alt="edit" src={Edit} className="edit-input" />
                    </div>
                    {errors.organizationName && touched.organizationName && (
                      <div className="form-label error">
                        {errors.organizationName}
                      </div>
                    )}
                  </div>

                  <div className="col-sm-6">
                    <div className="cv-input-field-container">
                      <label className="cv-input-label">
                        Level <span className="asterisk-required"></span>
                      </label>
                      <Select
              showSearchOnToggle={true}
              dropdownRenderMode="portal"
              className="cv-input-field"
              value={values.level}
              data={dropdownData}
              onSelect={(e) =>
                handleChange("level")({ target: { value: e } })
              }
              name="boarding"
              placeholder="Select Level"
              //disabled
            >
            </Select>
                    </div>
                    {errors.level && touched.level && (
                      <div className="form-label error">
                        {errors.level}
                      </div>
                    )}
                  </div>
                </div>
                <div className="row">
                <div className="col-sm-6">
                    <div className="cv-input-field-container">
                      <label htmlFor='ParentOrganizationForm' className="cv-input-label">
                        Parent Organization <span className="asterisk-required">*</span>
                      </label>
                      <input
                        className="cv-input-field pl-2"
                        onBlur={handleBlur}
                        type="text"
                        id='ParentOrganizationForm'
                        placeholder="Please enter Parent Organization"
                       value={values.parentOrganizationName}
                        onChange={handleChange("parentOrganizationName")}
                        name="parentOrganizationName"
                      />
                      <img alt="edit" src={Edit} className="edit-input" />
                    </div>
                    {errors.parentOrganizationName && touched.parentOrganizationName && (
                      <div className="form-label error">
                        {errors.parentOrganizationName}
                      </div>
                    )}
                  </div>
                  <div className="col-sm-6">
                    <div className="cv-input-field-container">
                      <label htmlFor='ChildOrganizationForm' className="cv-input-label">
                        Child Organization <span className="asterisk-required"></span>
                      </label>
                      <input
                        className="cv-input-field pl-2"
                        onBlur={handleBlur}
                        id='ChildOrganizationForm'
                        type="text"
                        placeholder="Please enter Child Organization"
                       value={values.childOrganizationName}
                        onChange={handleChange("childOrganizationName")}
                        name="childOrganizationName"
                      />
                      <img alt="edit" src={Edit} className="edit-input" />
                    </div>
                    {errors.childOrganizationName && touched.childOrganizationName && (
                      <div className="form-label error">
                        {errors.childOrganizationName}
                      </div>
                    )}
                  </div>
                </div>
                <div className="options-container">
                  <button
                    className="cancel-button"
                    type="reset"
                    onClick={handleReset}
                  >
                    Cancel
                  </button>
                  <button
                    type="submit"
                    disabled={isSubmitting}
                    className="save-button m-l-2"
                  >
                    Submit
                  </button>
                </div>
              </form>
            )}
          </div>
        );
      }}
    </Formik>
    )
}

OrganisationForm.propTypes = {
  InitialValues: PropTypes.any,
  handleReset: PropTypes.any,
  handleSubmit: PropTypes.any,
  validationSchema: PropTypes.any,
  loading: PropTypes.any,
  values: PropTypes.any,
  touched: PropTypes.any,
  errors: PropTypes.any,
  isSubmitting: PropTypes.any,
  handleChange: PropTypes.any,
  handleBlur: PropTypes.any,
}

export default OrganisationForm